import { render, staticRenderFns } from "./MovementsTableTotal.vue?vue&type=template&id=38673faa&scoped=true"
import script from "./MovementsTableTotal.vue?vue&type=script&lang=ts"
export * from "./MovementsTableTotal.vue?vue&type=script&lang=ts"
import style0 from "./MovementsTableTotal.vue?vue&type=style&index=0&id=38673faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38673faa",
  null
  
)

export default component.exports